import React, { useState } from 'react';
import { Container, Tabs, Tab, Box, Typography } from '@mui/material';

import FireTrendAnalysis from '../components/analysis/analysisfire';
import ForestCoverAnalysis from '../components/analysis/analysisforest';
import ClimateCorrelationAnalysis from '../components/analysis/analysisclimate';
import RegionalComparisonAnalysis from '../components/analysis/analysisregional';
import MangroveCoverAnalysis from '../components/analysis/analysismangrove';

// Helper component to keep tabs alive
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`analysis-tabpanel-${index}`}
      aria-labelledby={`analysis-tab-${index}`}
      {...other}
    >
      {/* CSS display 'none' (from the 'hidden' prop) 
        instead of conditional rendering (&&) used to keep the 
        component state alive when switching tabs.
      */}
      {children}
    </div>
  );
};

const Analysis = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ bgcolor: '#ffffff', minHeight: '100vh', p: { xs: 2, md: 3 } }}>
      <Container maxWidth="xl" disableGutters>
        <Box 
          sx={{ 
            mb: 3, 
            bgcolor: '#ffffff', 
          }}
        >
          <Tabs   
            value={activeTab} 
            onChange={(e, val) => setActiveTab(val)} 
            aria-label="analysis tabs"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              '& .MuiTab-root': {
                color: '#666',
                fontWeight: 500,
                fontSize: '0.95rem',
                textTransform: 'none',
                minHeight: '56px',
                '&.Mui-selected': {
                  color: '#4a7c59',
                  fontWeight: 600
                },
                '&:hover': {
                  color: '#4a7c59',
                  bgcolor: 'rgba(74, 124, 89, 0.04)'
                }
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#4a7c59',
                height: 3,
                borderRadius: '3px 3px 0 0'
              }
            }}
          >
            <Tab label="Fire Trend Analysis" />
            <Tab label="Forest Cover Analysis" />
            <Tab label="Mangrove Cover Analysis" />
            <Tab label="Climate Correlation" />
            <Tab label="Regional Comparison" />
          </Tabs>
        </Box>
        
        {/* Use the TabPanel to keep components mounted.
          This stops the charts from reloading every time you click a tab.
        */}
        <TabPanel value={activeTab} index={0}>
          <FireTrendAnalysis />
        </TabPanel>
        <TabPanel value={activeTab} index={1}>
          <ForestCoverAnalysis />
        </TabPanel>
        <TabPanel value={activeTab} index={2}>
          <MangroveCoverAnalysis />
        </TabPanel>
        <TabPanel value={activeTab} index={3}>
          <ClimateCorrelationAnalysis />
        </TabPanel>
        <TabPanel value={activeTab} index={4}>
          <RegionalComparisonAnalysis />
        </TabPanel>
      </Container>
    </Box>
  );
};

export default Analysis;